export default {
  data() {
    return {
      modalWidth: 920,
      modalHeight: 620,
      isResizing: false,
      resizeStartX: 0,
      resizeStartY: 0,
      resizeStartWidth: 0,
      resizeStartHeight: 0,
    };
  },
  computed: {
    vendorItemModalShellStyle() {
      return {
        width: `${this.modalWidth}px`,
        height: `${this.modalHeight}px`,
        maxWidth: '96vw',
        maxHeight: '92vh',
      };
    },
  },
  watch: {
    show(open) {
      if (open) {
        this.resetVendorItemModalSize();
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },
  },
  mounted() {
    this._onVendorItemModalKeydown = (event) => {
      if (event.key === 'Escape' && this.show) {
        this.$emit('close');
      }
    };
    document.addEventListener('keydown', this._onVendorItemModalKeydown);
  },
  beforeUnmount() {
    this.stopVendorItemModalResize();
    document.body.style.overflow = '';
    document.removeEventListener('keydown', this._onVendorItemModalKeydown);
  },
  methods: {
    resetVendorItemModalSize() {
      this.modalWidth = Math.min(920, window.innerWidth - 48);
      this.modalHeight = Math.min(620, window.innerHeight - 48);
    },
    startVendorItemModalResize(event) {
      event.preventDefault();
      const shell = this.$refs.modalShellRef;
      if (!shell) return;

      this.isResizing = true;
      this.resizeStartX = event.clientX;
      this.resizeStartY = event.clientY;
      this.resizeStartWidth = shell.offsetWidth;
      this.resizeStartHeight = shell.offsetHeight;
      this.modalWidth = this.resizeStartWidth;
      this.modalHeight = this.resizeStartHeight;

      document.addEventListener('mousemove', this.handleVendorItemModalResize);
      document.addEventListener('mouseup', this.stopVendorItemModalResize);
    },
    handleVendorItemModalResize(event) {
      if (!this.isResizing) return;

      const deltaX = event.clientX - this.resizeStartX;
      const deltaY = event.clientY - this.resizeStartY;
      const maxWidth = window.innerWidth - 32;
      const maxHeight = window.innerHeight - 32;

      this.modalWidth = Math.max(640, Math.min(maxWidth, this.resizeStartWidth + deltaX));
      this.modalHeight = Math.max(420, Math.min(maxHeight, this.resizeStartHeight + deltaY));
    },
    stopVendorItemModalResize() {
      if (!this.isResizing) return;
      this.isResizing = false;
      document.removeEventListener('mousemove', this.handleVendorItemModalResize);
      document.removeEventListener('mouseup', this.stopVendorItemModalResize);
    },
  },
};
